import { InAppNotificationType } from '@aslanpay/portal-common-lib';

const APPROVAL_NOTIFICATION_TYPES: InAppNotificationType[] = [
  'RECOGNITION_APPROVAL_REQUIRED',
  'RECOGNITION_APPROVAL_REMINDER_24H',
  'RECOGNITION_APPROVAL_REMINDER_48H',
];

export function getInAppNotificationPath(type: InAppNotificationType): string {
  if (APPROVAL_NOTIFICATION_TYPES.includes(type)) {
    return '/reward-and-recognition/approvals?tab=pendingApprovals';
  }

  if (
    type === 'RECOGNITION_RECEIVED' ||
    type === 'RECOGNITION_APPROVED_SENDER' ||
    type === 'RECOGNITION_DECLINED_SENDER'
  ) {
    return '/reward-and-recognition/the-roar';
  }

  return '/notifications';
}
